var ProgramsTabs = (function($) {

  var _s = {
    container: '.chm-block-programs-tabs',
    tab_container: '.tabs-container',
    tab_trigger: '.tabs-container .tab-trigger',
    tab_content: '.tab-content',
    program_content: '.program-content',
    spotlight_container: '.spotlight-container',
    spotlight: '.spotlight'
  };

  // URL Parameters - Get and Split URL
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };


  var _init = function() {
    _bindEvents();

    let active_program = (getUrlParameter('program_id'));

    if ( active_program ) {
      $(_s.container).find('[data-program-id="'+active_program+'"]').addClass('active');
    } else {
      $(_s.container).find('[data-program-id]').first().addClass('active');
    }

    // Make the URL pretty on page load
    // window.history.pushState(
    //   {"pageTitle":$(_s.tab_trigger+'.active').attr('data-program-title')+' - Christian Healthcare Ministries'},
    //   "",
    //   $(_s.tab_trigger+'.active').attr('data-program-url')
    // );

  };

  var _bindEvents = function() {

    // Tabs
    $(_s.tab_trigger).on('click', function(i) {
      let parent = $(this).parents(_s.container);
      let program_id = $(this).attr('data-program-id');

      $(this).siblings().removeClass('active');
      parent.find(_s.program_content).removeClass('active');
      parent.find(_s.spotlight).removeClass('active');

      parent.find('[data-program-id="'+program_id+'"]').addClass('active');

      // Make the URL pretty on when a program is selected
      // window.history.pushState(
      //   {"pageTitle":$(this).attr('data-program-title')+' - Christian Healthcare Ministries'},
      //   "",
      //   $(this).attr('data-program-url')
      // );

    });

    
  };

  return {
    init: _init
  };

})(jQuery);